import { motion } from "framer-motion";
import { Wheat, HandPlatter, Clock3 } from "lucide-react";
import { IMAGES } from "@/data/site";

const points = [
  { icon: Wheat, title: "Matèria primera", text: "Ingredients escollits per a un sabor autèntic." },
  { icon: HandPlatter, title: "Fet a mà", text: "Brioixeria i pans elaborats artesanalment." },
  { icon: Clock3, title: "Des de 1965", text: "Més de mig segle endolcint Calella." },
];

export const About = () => {
  return (
    <section
      id="sobre-nosaltres"
      data-testid="about-section"
      className="scroll-target relative py-24 md:py-32 bg-[#FDFBF7]"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10 grid md:grid-cols-2 gap-14 md:gap-20 items-center">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7 }}
        >
          <span className="text-sm uppercase tracking-[0.25em] font-semibold text-[#C8A24A]">
            Sobre nosaltres
          </span>
          <h2 className="font-display text-4xl sm:text-5xl font-semibold text-[#8B0000] mt-4 leading-tight">
            Tradició artesana des de 1965
          </h2>
          <p className="mt-6 text-[#5C4A3D] text-lg leading-relaxed">
            Som una pastisseria artesana, oberta des del 1965, on elaborem
            brioixeria i pans a mà. Cada dia preparem croissants, brioixeria
            catalana, milfulls, pastissos i molt més, amb la dedicació i la
            recepta de sempre.
          </p>

          <div className="mt-10 grid sm:grid-cols-3 gap-6">
            {points.map((p) => (
              <div key={p.title} data-testid={`about-point-${p.title}`}>
                <div className="w-11 h-11 rounded-full bg-[#8B0000]/10 flex items-center justify-center text-[#8B0000]">
                  <p.icon size={20} />
                </div>
                <h3 className="font-display text-lg font-semibold text-[#2C1E16] mt-3">
                  {p.title}
                </h3>
                <p className="text-sm text-[#5C4A3D] mt-1 leading-relaxed">{p.text}</p>
              </div>
            ))}
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.96 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
          className="relative"
        >
          <div className="absolute -inset-3 rounded-t-[10rem] rounded-b-2xl border border-[#C8A24A]/40" />
          <img
            src={IMAGES.baker}
            alt="Pastisser elaborant els dolços a mà"
            className="relative w-full h-[460px] md:h-[560px] object-cover rounded-t-[10rem] rounded-b-2xl shadow-xl"
          />
        </motion.div>
      </div>
    </section>
  );
};
